import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import MainLayout from '../layouts/MainLayout.vue';
import Login from '../views/Login.vue';
import Unauthorized from '../views/Unauthorized.vue';
import Dashboard from '../views/Dashboard.vue';
import Posventa from '../views/Posventa.vue';
import Users from '../views/admin/Users.vue';
import Roles from '../views/admin/Roles.vue';
import Permissions from '../views/admin/Permissions.vue';
import AuthService from '@/services/auth';
import axios from '@/plugins/axios.js';
import Vehicles from '@/views/Vehicles.vue';
import Clients from '@/views/Clients.vue';
import Resources from '@/views/Resources.vue';
import Services from '@/views/services/Main.vue';
import Checkin from '@/views/checkin/Checkin.vue';
import Sales from '@/views/sales/Sales.vue';
import TestEmail from '@/views/TestEmail.vue';
import Test from '@/views/Test.vue';

Vue.use(Router);

const routes = [
  { path: '/login', name: 'login', component: Login },
  { path: '*', redirect: '/login' },
  {
    path: '/',
    component: MainLayout,
    children: [
      { path: '/unauthorized', name: 'unauthorized', component: Unauthorized },

      {
        path: '/', component: Dashboard, meta: {
          requiresAuth: true,
        }
      },
      {
        path: '/testEmail', component: TestEmail,
      },
      {
        path: '/posventa', component: Posventa,
        meta: {
          requiresAuth: true,
          permission: 'posventa',
        }
      },
      {
        path: '/clients', component: Clients,
        meta: {
          requiresAuth: true,
          permission: 'clients',
        }
      },
      {
        path: "/vehicles/zero-mileage",
        component: Vehicles,
        meta: {
          requiresAuth: true,
          permission: "vehicles",
        },
        props: { filterState: ["salon"] },
      },
      {
        path: "/vehicles/posventa",
        component: Vehicles,
        meta: {
          requiresAuth: true,
          permission: "vehicles",
        },
        props: { filterState: ["vendido","otros"] },
      },
      {
        path: '/resources', component: Resources,
        meta: {
          requiresAuth: true,
          permission: 'resources',
        }
      },
      {
        path: '/services', component: Services, name: 'services',
        meta: {
          requiresAuth: true,
          permission: 'services',
        }
      },
      {
        path: '/checkin', component: Checkin, name: 'checkin',
        props: route => ({ item: route.query.item ? JSON.parse(route.query.item) : null }),
        meta: {
          requiresAuth: true,
          permission: 'checkin',
        }
      },
      {
        path: '/sales', component: Sales,
        meta: {
          requiresAuth: true,
          permission: 'sales',
        }
      },
      {
        path: '/admin/users', component: Users, meta: {
          permission: 'admin',
          requiresAuth: true
        }
      },
      {
        path: '/admin/roles', component: Roles, meta: {
          permission: 'admin',
          requiresAuth: true
        }
      },
      {
        path: '/admin/permissions', component: Permissions, meta: {
          permission: 'admin',
          requiresAuth: true
        }
      },
    ],
  },
  /*{
    path: '/admin/roles',
    component: () => import('@/pages/admin/Roles.vue'),
  },
  {
    path: '/admin/permissions',
    component: () => import('@/pages/admin/Permissions.vue'),
  },*/

];

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach(async (to, from, next) => {

  if (to.meta.requiresAuth) {
    const isAuthenticated = await AuthService.checkAuthentication();
    if (!isAuthenticated) {
      next({ path: '/login' });
    } else {
      if (to.meta.permission) {
        const hasPermission = await checkUserPermission(to.meta.permission);
        if (hasPermission) {
          return next();
        } else {
          return next({ path: '/unauthorized' });
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});
async function checkUserPermission(permissionName) {
  try {
    const user = store.getters['auth/getUser'];
    if (user.name) {
      if (user.roles[0].permissions.find(per => per.name === permissionName)) {
        return true;
      } else {
        return false;
      }
    } else {
      // Si el usuario no está disponible, intentamos obtenerlo
      const token = localStorage.getItem("token");
      // Utilizamos await aquí para esperar la respuesta de la petición HTTP
      const response = await axios.post("/admin/getUser", { token: token });
      // Actualizamos el estado y permisos en Vuex
      store.commit('auth/setUser', response.data.user);
      // Devolvemos el resultado de la verificación de permisos
      return response.data.user.roles[0].permissions.find(per => per.name === permissionName) !== undefined;
    }
  } catch (error) {
    console.error('Error al verificar permisos:', error);
    return false;
  }
}

export default router;